import axios from 'axios';

const instance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: 5000, // Set a timeout value in milliseconds
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Add an interceptor to handle authentication
instance.interceptors.request.use(
  (config) => {
    config.headers['apiKey'] = import.meta.env.VITE_API_KEY;
    config.headers['Content-Type'] = 'application/json';

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;
